import React from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

import ReportHistoryHeader from "./ReportHistoryHeader";
import ReportHistoryBody from "./ReportHistoryBody";

const ReportHistoryTable = ({ historyData, open }) => {
  const {
    reportHistories,
    customerReportHistoryCount,
    phoneReportHistoryCount,
    socialReportHistoryCount,
    propertyReportHistoryCount,
    autoReportHistoryCount
  } = historyData;

  const aggregatedData =
    customerReportHistoryCount +
    phoneReportHistoryCount +
    socialReportHistoryCount +
    propertyReportHistoryCount +
    autoReportHistoryCount;

  const createData = (reportType, reportInfo, reportToken, score) => {
    return {
      reportType,
      reportInfo,
      reportToken,
      score,
    };
  };
  const ReportData = reportHistories?.map(
    ({ reportType, reportInfo, reportToken, score }) =>
      createData(reportType, reportInfo, reportToken, score)
  );
  return (
    <div className={`${open ? "show-table" : "hide-table"}`}>
      <h4 className="aggregated-report-count">
        Total Reports {aggregatedData}
      </h4>
      <TableContainer>
        <Table className="table">
          <ReportHistoryHeader />
          <ReportHistoryBody reportData={ReportData} />
        </Table>
      </TableContainer>
      <div className="bottom-footer"></div>
    </div>
  );
};

export default ReportHistoryTable;
